export const canUseNativeAppleAuth = ({ isNativeApp, caps }) => {
  return Boolean(
    isNativeApp
    && caps?.platform === 'ios'
    && caps?.appleAuth
    && caps?.appleAuthAvailable !== false
  );
};

const translate = (t, key, fallback) => (typeof t === 'function' ? t(key, fallback) : fallback);

export const getAuthQueryErrorMessage = (code, t) => {
  if (code === 'google_login_failed' || code === 'apple_login_failed') {
    return translate(t, 'auth.noAccountFound', 'No account found. Please register first to create one.');
  }

  if (code === 'google_register_failed' || code === 'apple_register_failed') {
    return translate(
      t,
      'auth.authCreateFailed',
      'Authentication failed while creating the account. Please try again.'
    );
  }

  if (code === 'account_deleted') {
    return translate(t, 'auth.accountDeleted', 'This account has been deleted.');
  }

  if (code === 'apple_missing_email') {
    return translate(
      t,
      'auth.appleMissingEmail',
      'Apple Sign In did not provide an email address for this account.'
    );
  }

  if (code === 'ERR_APPLE_AUTH_UNAVAILABLE') {
    return translate(
      t,
      'auth.appleUnavailableDetailed',
      'Apple Sign In is unavailable on this simulator or device. Test on a real iPhone if the simulator cannot complete Apple authentication.'
    );
  }

  if (code === 'apple_auth_internal_error') {
    return translate(
      t,
      'auth.appleInternalError',
      'Apple Sign In reached Forza but the server could not verify the Apple token. Check backend logs and Apple bundle configuration.'
    );
  }

  if (code === 'apple_invalid_identity') {
    return translate(
      t,
      'auth.appleInvalidIdentity',
      'Apple Sign In did not provide a valid account identifier. Please try again.'
    );
  }

  if (typeof code === 'string' && code.trim()) {
    return translate(t, 'auth.authFailed', 'Authentication failed. Please try again.');
  }

  return null;
};
